// RetailCliQ ERP — i18n Translations
// Grouped for the Globalization selector: India (primary 5) -> India (Others) -> International (top 5)

export const LANGUAGES = [
  // ── India — primary (English default, then Hindi, Telugu, Tamil, Kannada) ──
  { code: 'en', name: 'English', nativeName: 'English', dir: 'ltr', locale: 'en-IN', flag: '\uD83C\uDDEE\uD83C\uDDF3', group: 'india' },
  { code: 'hi', name: 'Hindi', nativeName: '\u0939\u093f\u0902\u0926\u0940', dir: 'ltr', locale: 'hi-IN', flag: '\uD83C\uDDEE\uD83C\uDDF3', group: 'india' },
  { code: 'te', name: 'Telugu', nativeName: '\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41', dir: 'ltr', locale: 'te-IN', flag: '\uD83C\uDDEE\uD83C\uDDF3', group: 'india' },
  { code: 'ta', name: 'Tamil', nativeName: '\u0ba4\u0bae\u0bbf\u0bb4\u0bcd', dir: 'ltr', locale: 'ta-IN', flag: '\uD83C\uDDEE\uD83C\uDDF3', group: 'india' },
  { code: 'kn', name: 'Kannada', nativeName: '\u0c95\u0ca8\u0ccd\u0ca8\u0ca1', dir: 'ltr', locale: 'kn-IN', flag: '\uD83C\uDDEE\uD83C\uDDF3', group: 'india' },
  // ── India — others ──
  { code: 'gu', name: 'Gujarati', nativeName: '\u0a97\u0ac1\u0a9c\u0ab0\u0abe\u0aa4\u0ac0', dir: 'ltr', locale: 'gu-IN', flag: '\uD83C\uDDEE\uD83C\uDDF3', group: 'india-other' },
  { code: 'mr', name: 'Marathi', nativeName: '\u092e\u0930\u093e\u0920\u0940', dir: 'ltr', locale: 'mr-IN', flag: '\uD83C\uDDEE\uD83C\uDDF3', group: 'india-other' },
  // ── International — top 5 ──
  { code: 'ar', name: 'Arabic', nativeName: '\u0627\u0644\u0639\u0631\u0628\u064a\u0629', dir: 'rtl', locale: 'ar-AE', flag: '\uD83C\uDDE6\uD83C\uDDEA', group: 'international' },
  { code: 'fr', name: 'French', nativeName: 'Fran\u00e7ais', dir: 'ltr', locale: 'fr-FR', flag: '\uD83C\uDDEB\uD83C\uDDF7', group: 'international' },
  { code: 'es', name: 'Spanish', nativeName: 'Espa\u00f1ol', dir: 'ltr', locale: 'es-ES', flag: '\uD83C\uDDEA\uD83C\uDDF8', group: 'international' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', dir: 'ltr', locale: 'de-DE', flag: '\uD83C\uDDE9\uD83C\uDDEA', group: 'international' },
  { code: 'zh', name: 'Chinese', nativeName: '\u4e2d\u6587', dir: 'ltr', locale: 'zh-CN', flag: '\uD83C\uDDE8\uD83C\uDDF3', group: 'international' },
];

export const CURRENCIES = [
  { code: 'INR', symbol: '\u20b9', name: 'Indian Rupee', locale: 'en-IN' },
  { code: 'USD', symbol: '$', name: 'US Dollar', locale: 'en-US' },
  { code: 'EUR', symbol: '\u20ac', name: 'Euro', locale: 'de-DE' },
  { code: 'GBP', symbol: '\u00a3', name: 'British Pound', locale: 'en-GB' },
  { code: 'AED', symbol: '\u062f.\u0625', name: 'UAE Dirham', locale: 'ar-AE' },
  { code: 'SAR', symbol: '\ufdfc', name: 'Saudi Riyal', locale: 'ar-SA' },
  { code: 'JPY', symbol: '\u00a5', name: 'Japanese Yen', locale: 'ja-JP' },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar', locale: 'en-SG' },
  { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit', locale: 'ms-MY' },
  { code: 'THB', symbol: '\u0e3f', name: 'Thai Baht', locale: 'th-TH' },
];

export const TRANSLATIONS = {
  en: {
    welcomeBack: 'Welcome Back',
    signInToAccount: 'Sign in to your RetailCliQ account',
    usernamePlaceholder: 'Username or Email',
    passwordPlaceholder: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    signInBtn: 'Sign In',
    signingIn: 'Signing in...',
    requestAccess: 'Request Access',
    newTo: 'New to RetailCliQ?',
    verifyIdentity: 'Verify Your Identity',
    otpSentTo: 'Code sent to',
    verifyOtp: 'Verify OTP',
    resendOtp: 'Resend OTP',
    backToLogin: 'Back to Login',
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    todayPulse: "Today's Pulse",
    recentActivity: 'Recent Activity',
    comingSoon: 'Coming Soon',
    selectBranch: 'Select Branch',
    selectCompany: 'Select Company',
    systemStatus: 'System Status',
    allSystemsNormal: 'All Systems Normal',
    operational: 'Operational',
    language: 'Language',
    currency: 'Currency',
    selectLanguage: 'Select Language',
    selectCurrency: 'Select Currency',
    demoCredentials: 'Demo Credentials',
    noMfaRequired: '(No MFA)',
    uptime: 'Uptime',
    activeUsers: 'Active Users',
    todayRevenue: "Today's Revenue",
    pendingApprovals: 'Pending Approvals',
    lowStockAlerts: 'Low Stock Alerts',
    recentLogins: 'Recent Logins',
    quickActions: 'Quick Actions',
    contactSupport: 'Contact Support',
    versionInfo: 'Version Info',
  },
  hi: {
    welcomeBack: '\u0935\u093e\u092a\u0938\u0940 \u092a\u0930 \u0938\u094d\u0935\u093e\u0917\u0924 \u0939\u0948',
    signInToAccount: '\u0905\u092a\u0928\u0947 RetailCliQ \u0916\u093e\u0924\u0947 \u092e\u0947\u0902 \u0932\u0949\u0917 \u0907\u0928 \u0915\u0930\u0947\u0902',
    usernamePlaceholder: '\u0909\u092a\u092f\u094b\u0917\u0915\u0930\u094d\u0924\u093e \u0928\u093e\u092e \u092f\u093e \u0908\u092e\u0947\u0932',
    passwordPlaceholder: '\u092a\u093e\u0938\u0935\u0930\u094d\u0921',
    rememberMe: '\u092e\u0941\u091d\u0947 \u092f\u093e\u0926 \u0930\u0916\u0947\u0902',
    forgotPassword: '\u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u092d\u0942\u0932 \u0917\u090f?',
    signInBtn: '\u0932\u0949\u0917 \u0907\u0928',
    signingIn: '\u0932\u0949\u0917 \u0907\u0928 \u0939\u094b \u0930\u0939\u093e \u0939\u0948...',
    requestAccess: '\u092a\u0939\u0941\u0902\u091a \u0905\u0928\u0941\u0930\u094b\u0927',
    newTo: 'RetailCliQ \u092e\u0947\u0902 \u0928\u090f \u0939\u0948\u0902?',
    verifyIdentity: '\u0905\u092a\u0928\u0940 \u092a\u0939\u091a\u093e\u0928 \u0938\u0924\u094d\u092f\u093e\u092a\u093f\u0924 \u0915\u0930\u0947\u0902',
    otpSentTo: '\u0915\u094b\u0921 \u092d\u0947\u091c\u093e \u0917\u092f\u093e',
    verifyOtp: 'OTP \u0938\u0924\u094d\u092f\u093e\u092a\u093f\u0924 \u0915\u0930\u0947\u0902',
    resendOtp: 'OTP \u092a\u0941\u0928\u0903 \u092d\u0947\u091c\u0947\u0902',
    backToLogin: '\u0932\u0949\u0917\u093f\u0928 \u092a\u0930 \u0935\u093e\u092a\u0938',
    goodMorning: '\u0938\u0941\u092a\u094d\u0930\u092d\u093e\u0924',
    goodAfternoon: '\u0936\u0941\u092d \u0905\u092a\u0930\u093e\u0939\u094d\u0928',
    goodEvening: '\u0936\u0941\u092d \u0938\u0902\u0927\u094d\u092f\u093e',
    todayPulse: '\u0906\u091c \u0915\u0940 \u0916\u092c\u0930',
    recentActivity: '\u0939\u093e\u0932 \u0915\u0940 \u0917\u0924\u093f\u0935\u093f\u0927\u093f',
    comingSoon: '\u091c\u0932\u094d\u0926 \u0906 \u0930\u0939\u093e \u0939\u0948',
    selectBranch: '\u0936\u093e\u0916\u093e \u091a\u0941\u0928\u0947\u0902',
    selectCompany: '\u0915\u0902\u092a\u0928\u0940 \u091a\u0941\u0928\u0947\u0902',
    systemStatus: '\u0938\u093f\u0938\u094d\u091f\u092e \u0938\u094d\u0925\u093f\u0924\u093f',
    allSystemsNormal: '\u0938\u092d\u0940 \u0938\u093f\u0938\u094d\u091f\u092e \u0938\u0930\u094d\u0935\u093c\u0932 \u0939\u0948\u0902',
    operational: '\u0938\u0902\u091a\u093e\u0932\u0928 \u092e\u0947\u0902',
    language: '\u092d\u093e\u0937\u093e',
    currency: '\u092e\u0941\u0926\u094d\u0930\u093e',
    selectLanguage: '\u092d\u093e\u0937\u093e \u091a\u0941\u0928\u0947\u0902',
    selectCurrency: '\u092e\u0941\u0926\u094d\u0930\u093e \u091a\u0941\u0928\u0947\u0902',
    demoCredentials: '\u0921\u0947\u092e\u094b \u0915\u094d\u0930\u0947\u0921\u0947\u0902\u0936\u093f\u092f\u0932',
    noMfaRequired: '(MFA \u0928\u0939\u0940\u0902)',
    uptime: '\u0905\u092a\u091f\u093e\u0907\u092e',
    activeUsers: '\u0938\u0915\u094d\u0930\u093f\u092f \u0909\u092a\u092f\u094b\u0917\u0915\u0930\u094d\u0924\u093e',
    todayRevenue: '\u0906\u091c \u0915\u0940 \u0906\u092e\u0926\u0928\u0940',
    pendingApprovals: '\u0932\u0902\u092c\u093f\u0924 \u0905\u0928\u0941\u092e\u094b\u0926\u0928',
    lowStockAlerts: '\u0915\u092e \u0938\u094d\u091f\u0949\u0915 \u0905\u0932\u0930\u094d\u091f',
    recentLogins: '\u0939\u093e\u0932\u093f\u092f\u093e \u0932\u0949\u0917\u093f\u0928',
    quickActions: '\u0924\u094d\u0935\u0930\u093f\u0924 \u0915\u093e\u0930\u094d\u0930\u0935\u093e\u0908',
    contactSupport: '\u0938\u0939\u093e\u092f\u0924\u093e \u0938\u0902\u092a\u0930\u094d\u0915 \u0915\u0930\u0947\u0902',
    versionInfo: '\u0938\u0902\u0938\u094d\u0915\u0930\u0923 \u091c\u093e\u0928\u0915\u093e\u0930\u0940',
  },
  ar: {
    welcomeBack: '\u0645\u0631\u062d\u0628\u0627\u064b \u0628\u0639\u0648\u062f\u062a\u0643',
    signInToAccount: '\u0633\u062c\u0651\u0644 \u0627\u0644\u062f\u062e\u0648\u0644 \u0625\u0644\u0649 \u062d\u0633\u0627\u0628\u0643',
    usernamePlaceholder: '\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645 \u0623\u0648 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a',
    passwordPlaceholder: '\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631',
    rememberMe: '\u062a\u0630\u0643\u0651\u0631\u0646\u064a',
    forgotPassword: '\u0646\u0633\u064a\u062a \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u061f',
    signInBtn: '\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644',
    signingIn: '\u062c\u0627\u0631\u064a \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644...',
    requestAccess: '\u0637\u0644\u0628 \u0627\u0644\u0648\u0635\u0648\u0644',
    newTo: '\u062c\u062f\u064a\u062f \u0641\u064a RetailCliQ\u061f',
    verifyIdentity: '\u062a\u062d\u0642\u0651\u0642 \u0645\u0646 \u0647\u0648\u064a\u062a\u0643',
    otpSentTo: '\u062a\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632 \u0625\u0644\u0649',
    verifyOtp: '\u062a\u062d\u0642\u064a\u0642 OTP',
    resendOtp: '\u0625\u0639\u0627\u062f\u0629 \u0625\u0631\u0633\u0627\u0644 OTP',
    backToLogin: '\u0627\u0644\u0639\u0648\u062f\u0629 \u0644\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644',
    goodMorning: '\u0635\u0628\u0627\u062d \u0627\u0644\u062e\u064a\u0631',
    goodAfternoon: '\u0645\u0633\u0627\u0621 \u0627\u0644\u062e\u064a\u0631',
    goodEvening: '\u0645\u0633\u0627\u0621 \u0627\u0644\u0646\u0648\u0631',
    todayPulse: '\u0646\u0628\u0636 \u0627\u0644\u064a\u0648\u0645',
    recentActivity: '\u0627\u0644\u0646\u0634\u0627\u0637 \u0627\u0644\u0623\u062e\u064a\u0631',
    comingSoon: '\u0642\u0631\u064a\u0628\u0627\u064b',
    selectBranch: '\u0627\u062e\u062a\u0631 \u0627\u0644\u0641\u0631\u0639',
    selectCompany: '\u0627\u062e\u062a\u0631 \u0627\u0644\u0634\u0631\u0643\u0629',
    systemStatus: '\u062d\u0627\u0644\u0629 \u0627\u0644\u0646\u0638\u0627\u0645',
    allSystemsNormal: '\u062c\u0645\u064a\u0639 \u0627\u0644\u0623\u0646\u0638\u0645\u0629 \u0637\u0628\u064a\u0639\u064a\u0629',
    operational: '\u062a\u0634\u063a\u064a\u0644\u064a',
    language: '\u0627\u0644\u0644\u063a\u0629',
    currency: '\u0627\u0644\u0639\u0645\u0644\u0629',
    selectLanguage: '\u0627\u062e\u062a\u0631 \u0627\u0644\u0644\u063a\u0629',
    selectCurrency: '\u0627\u062e\u062a\u0631 \u0627\u0644\u0639\u0645\u0644\u0629',
    demoCredentials: '\u0628\u064a\u0627\u0646\u0627\u062a \u062a\u062c\u0631\u064a\u0628\u064a\u0629',
    noMfaRequired: '(\u0628\u062f\u0648\u0646 MFA)',
    uptime: '\u0648\u0642\u062a \u0627\u0644\u062a\u0634\u063a\u064a\u0644',
    activeUsers: '\u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645\u0648\u0646 \u0627\u0644\u0646\u0634\u0637\u0648\u0646',
    todayRevenue: '\u0625\u064a\u0631\u0627\u062f\u0627\u062a \u0627\u0644\u064a\u0648\u0645',
    pendingApprovals: '\u0645\u0648\u0627\u0641\u0642\u0627\u062a \u0645\u0639\u0644\u0642\u0629',
    lowStockAlerts: '\u062a\u0646\u0628\u064a\u0647\u0627\u062a \u0627\u0644\u0645\u062e\u0632\u0648\u0646',
    recentLogins: '\u0622\u062e\u0631 \u062a\u0633\u062c\u064a\u0644\u0627\u062a',
    quickActions: '\u0625\u062c\u0631\u0627\u0621\u0627\u062a \u0633\u0631\u064a\u0639\u0629',
    contactSupport: '\u062a\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062f\u0639\u0645',
    versionInfo: '\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u0625\u0635\u062f\u0627\u0631',
  },
  ta: {
    welcomeBack: '\u0bae\u0bc0\u0ba3\u0bcd\u0b9f\u0bc1\u0bae\u0bcd \u0bb5\u0bb0\u0bc1\u0b95',
    signInToAccount: '\u0b89\u0b99\u0bcd\u0b95\u0bb3\u0bcd RetailCliQ \u0b95\u0ba3\u0b95\u0bcd\u0b95\u0bbf\u0bb2\u0bcd \u0b89\u0bb3\u0bcd\u0ba8\u0bc1\u0bb4\u0bc8\u0b95',
    usernamePlaceholder: '\u0baa\u0baf\u0ba9\u0bb0\u0bcd \u0baa\u0bc6\u0baf\u0bb0\u0bcd \u0b85\u0bb2\u0bcd\u0bb2\u0ba4\u0bc1 \u0bae\u0bbf\u0ba9\u0bcd\u0ba9\u0b9e\u0bcd\u0b9a\u0bb2\u0bcd',
    passwordPlaceholder: '\u0b95\u0b9f\u0bb5\u0bc1\u0b9a\u0bcd\u0b9a\u0bca\u0bb2\u0bcd',
    rememberMe: '\u0b8e\u0ba9\u0bcd\u0ba9\u0bc8 \u0ba8\u0bbf\u0ba9\u0bc8\u0bb5\u0bbf\u0bb2\u0bcd \u0bb5\u0bc8',
    forgotPassword: '\u0b95\u0b9f\u0bb5\u0bc1\u0b9a\u0bcd\u0b9a\u0bca\u0bb2\u0bcd \u0bae\u0bb1\u0ba8\u0bcd\u0ba4\u0bc1\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f\u0ba4\u0bbe?',
    signInBtn: '\u0b89\u0bb3\u0bcd\u0ba8\u0bc1\u0bb4\u0bc8',
    signingIn: '\u0b89\u0bb3\u0bcd\u0ba8\u0bc1\u0bb4\u0bc8\u0b95\u0bbf\u0bb1\u0ba4\u0bc1...',
    requestAccess: '\u0b85\u0ba3\u0bc1\u0b95\u0bb2\u0bcd \u0b95\u0bcb\u0bb0\u0bbf\u0b95\u0bcd\u0b95\u0bc8',
    newTo: 'RetailCliQ-\u0bb2\u0bcd \u0baa\u0bc1\u0ba4\u0bbf\u0baf\u0bb5\u0bb0\u0bbe?',
    verifyIdentity: '\u0b89\u0b99\u0bcd\u0b95\u0bb3\u0bcd \u0b85\u0b9f\u0bc8\u0baf\u0bbe\u0bb3\u0ba4\u0bcd\u0ba4\u0bc8 \u0b9a\u0bb0\u0bbf\u0baa\u0bbe\u0bb0\u0bcd\u0b95\u0bcd\u0b95\u0bb5\u0bc1\u0bae\u0bcd',
    otpSentTo: '\u0b95\u0bc1\u0bb1\u0bbf\u0baf\u0bbf\u0b9f\u0bcd\u0b9f \u0b87\u0b9f\u0ba4\u0bcd\u0ba4\u0bbf\u0bb2\u0bcd \u0b85\u0ba9\u0bc1\u0baa\u0bcd\u0baa\u0baa\u0bcd\u0baa\u0b9f\u0bcd\u0b9f\u0ba4\u0bc1',
    verifyOtp: 'OTP \u0b9a\u0bb0\u0bbf\u0baa\u0bbe\u0bb0\u0bcd\u0b95\u0bcd\u0b95\u0bb5\u0bc1\u0bae\u0bcd',
    resendOtp: 'OTP \u0bae\u0bc0\u0ba3\u0bcd\u0b9f\u0bc1\u0bae\u0bcd \u0b85\u0ba9\u0bc1\u0baa\u0bcd\u0baa\u0bc1',
    backToLogin: '\u0b89\u0bb3\u0bcd\u0ba8\u0bc1\u0bb4\u0bc8\u0bb5\u0bc1\u0b95\u0bcd\u0b95\u0bc1 \u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0bcd\u0baa\u0bc1',
    goodMorning: '\u0b95\u0bbe\u0bb2\u0bc8 \u0bb5\u0ba3\u0b95\u0bcd\u0b95\u0bae\u0bcd',
    goodAfternoon: '\u0bae\u0ba4\u0bbf\u0baf \u0bb5\u0ba3\u0b95\u0bcd\u0b95\u0bae\u0bcd',
    goodEvening: '\u0bae\u0bbe\u0bb2\u0bc8 \u0bb5\u0ba3\u0b95\u0bcd\u0b95\u0bae\u0bcd',
    todayPulse: '\u0b87\u0ba9\u0bcd\u0bb1\u0bc8\u0baf \u0b9a\u0bc6\u0baf\u0bcd\u0ba4\u0bbf',
    recentActivity: '\u0b9a\u0bae\u0bc0\u0baa\u0ba4\u0bcd\u0ba4\u0bbf\u0baf \u0b9a\u0bc6\u0baf\u0bb2\u0bcd\u0baa\u0bbe\u0b9f\u0bc1',
    comingSoon: '\u0bb5\u0bbf\u0bb0\u0bc8\u0bb5\u0bbf\u0bb2\u0bcd \u0bb5\u0bb0\u0bc1\u0bae\u0bcd',
    selectBranch: '\u0b95\u0bbf\u0bb3\u0bc8 \u0ba4\u0bc7\u0bb0\u0bcd\u0bb5\u0bc1 \u0b9a\u0bc6\u0baf\u0bcd',
    selectCompany: '\u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0bae\u0bcd \u0ba4\u0bc7\u0bb0\u0bcd\u0bb5\u0bc1 \u0b9a\u0bc6\u0baf\u0bcd',
    systemStatus: '\u0b95\u0ba3\u0bbf\u0ba9\u0bbf \u0ba8\u0bbf\u0bb2\u0bc8',
    allSystemsNormal: '\u0b85\u0ba9\u0bc8\u0ba4\u0bcd\u0ba4\u0bc1\u0bae\u0bcd \u0b9a\u0bb0\u0bbf',
    operational: '\u0b87\u0baf\u0b99\u0bcd\u0b95\u0bc1\u0b95\u0bbf\u0bb1\u0ba4\u0bc1',
    language: '\u0bae\u0bca\u0bb4\u0bbf',
    currency: '\u0ba8\u0bbe\u0ba3\u0baf\u0bae\u0bcd',
    selectLanguage: '\u0bae\u0bca\u0bb4\u0bbf \u0ba4\u0bc7\u0bb0\u0bcd\u0bb5\u0bc1',
    selectCurrency: '\u0ba8\u0bbe\u0ba3\u0baf\u0bae\u0bcd \u0ba4\u0bc7\u0bb0\u0bcd\u0bb5\u0bc1',
    demoCredentials: '\u0b9f\u0bc6\u0bae\u0bcb \u0ba4\u0b95\u0bb5\u0bb2\u0bcd',
    noMfaRequired: '(MFA \u0ba4\u0bc7\u0bb5\u0bc8\u0baf\u0bbf\u0bb2\u0bcd\u0bb2\u0bc8)',
    uptime: '\u0b87\u0baf\u0b95\u0bcd\u0b95 \u0ba8\u0bc7\u0bb0\u0bae\u0bcd',
    activeUsers: '\u0b9a\u0bc1\u0bb1\u0bc1\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0baf\u0ba9\u0bb0\u0bcd\u0b95\u0bb3\u0bcd',
    todayRevenue: '\u0b87\u0ba9\u0bcd\u0bb1\u0bc8\u0baf \u0bb5\u0bb0\u0bc1\u0bae\u0bbe\u0ba9\u0bae\u0bcd',
    pendingApprovals: '\u0ba8\u0bbf\u0bb2\u0bc1\u0bb5\u0bc8 \u0b85\u0ba9\u0bc1\u0bae\u0ba4\u0bbf\u0b95\u0bb3\u0bcd',
    lowStockAlerts: '\u0b95\u0bc1\u0bb1\u0bc8\u0b95\u0bc1\u0bb1\u0bbf \u0b8e\u0b9a\u0bcd\u0b9a\u0bb0\u0bbf\u0b95\u0bcd\u0b95\u0bc8',
    recentLogins: '\u0b9a\u0bae\u0bc0\u0baa \u0b89\u0bb3\u0bcd\u0ba8\u0bc1\u0bb4\u0bc8\u0bb5\u0bc1\u0b95\u0bb3\u0bcd',
    quickActions: '\u0bb5\u0bbf\u0bb0\u0bc8\u0bb5\u0bbe\u0ba9 \u0b9a\u0bc6\u0baf\u0bb2\u0bcd\u0b95\u0bb3\u0bcd',
    contactSupport: '\u0b89\u0ba4\u0bb5\u0bbf \u0ba4\u0bca\u0b9f\u0bb0\u0bcd\u0baa\u0bc1',
    versionInfo: '\u0baa\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1 \u0ba4\u0b95\u0bb5\u0bb2\u0bcd',
  },
  fr: {
    welcomeBack: 'Bon retour',
    signInToAccount: 'Connectez-vous \u00e0 votre compte RetailCliQ',
    usernamePlaceholder: "Nom d'utilisateur ou Email",
    passwordPlaceholder: 'Mot de passe',
    rememberMe: 'Se souvenir de moi',
    forgotPassword: 'Mot de passe oubli\u00e9?',
    signInBtn: 'Se connecter',
    signingIn: 'Connexion en cours...',
    requestAccess: "Demander l'acc\u00e8s",
    newTo: 'Nouveau sur RetailCliQ?',
    verifyIdentity: 'V\u00e9rifiez votre identit\u00e9',
    otpSentTo: 'Code envoy\u00e9 \u00e0',
    verifyOtp: 'V\u00e9rifier OTP',
    resendOtp: 'Renvoyer OTP',
    backToLogin: 'Retour \u00e0 la connexion',
    goodMorning: 'Bonjour',
    goodAfternoon: 'Bon apr\u00e8s-midi',
    goodEvening: 'Bonsoir',
    todayPulse: 'Pulse du jour',
    recentActivity: 'Activit\u00e9 r\u00e9cente',
    comingSoon: 'Bient\u00f4t disponible',
    selectBranch: 'S\u00e9lectionner une agence',
    selectCompany: 'S\u00e9lectionner une soci\u00e9t\u00e9',
    systemStatus: 'Statut syst\u00e8me',
    allSystemsNormal: 'Tous les syst\u00e8mes normaux',
    operational: 'Op\u00e9rationnel',
    language: 'Langue',
    currency: 'Devise',
    selectLanguage: 'S\u00e9lectionner la langue',
    selectCurrency: 'S\u00e9lectionner la devise',
    demoCredentials: 'Identifiants de d\u00e9mo',
    noMfaRequired: '(Sans MFA)',
    uptime: 'Disponibilit\u00e9',
    activeUsers: 'Utilisateurs actifs',
    todayRevenue: "Revenus d'aujourd'hui",
    pendingApprovals: 'Approbations en attente',
    lowStockAlerts: 'Alertes stock bas',
    recentLogins: 'Connexions r\u00e9centes',
    quickActions: 'Actions rapides',
    contactSupport: 'Contacter le support',
    versionInfo: 'Informations de version',
  },
  es: {
    welcomeBack: 'Bienvenido de nuevo',
    signInToAccount: 'Inicia sesi\u00f3n en tu cuenta RetailCliQ',
    usernamePlaceholder: 'Usuario o Email',
    passwordPlaceholder: 'Contrase\u00f1a',
    rememberMe: 'Recu\u00e9rdame',
    forgotPassword: '\u00bfOlvidaste la contrase\u00f1a?',
    signInBtn: 'Iniciar sesi\u00f3n',
    signingIn: 'Iniciando sesi\u00f3n...',
    requestAccess: 'Solicitar acceso',
    newTo: '\u00bfNuevo en RetailCliQ?',
    verifyIdentity: 'Verifica tu identidad',
    otpSentTo: 'C\u00f3digo enviado a',
    verifyOtp: 'Verificar OTP',
    resendOtp: 'Reenviar OTP',
    backToLogin: 'Volver al inicio de sesi\u00f3n',
    goodMorning: 'Buenos d\u00edas',
    goodAfternoon: 'Buenas tardes',
    goodEvening: 'Buenas noches',
    todayPulse: 'Pulso del d\u00eda',
    recentActivity: 'Actividad reciente',
    comingSoon: 'Pr\u00f3ximamente',
    selectBranch: 'Seleccionar sucursal',
    selectCompany: 'Seleccionar empresa',
    systemStatus: 'Estado del sistema',
    allSystemsNormal: 'Todos los sistemas normales',
    operational: 'Operativo',
    language: 'Idioma',
    currency: 'Moneda',
    selectLanguage: 'Seleccionar idioma',
    selectCurrency: 'Seleccionar moneda',
    demoCredentials: 'Credenciales de demo',
    noMfaRequired: '(Sin MFA)',
    uptime: 'Disponibilidad',
    activeUsers: 'Usuarios activos',
    todayRevenue: 'Ingresos de hoy',
    pendingApprovals: 'Aprobaciones pendientes',
    lowStockAlerts: 'Alertas de stock bajo',
    recentLogins: 'Inicios de sesi\u00f3n recientes',
    quickActions: 'Acciones r\u00e1pidas',
    contactSupport: 'Contactar soporte',
    versionInfo: 'Informaci\u00f3n de versi\u00f3n',
  },
  gu: {
    welcomeBack: '\u0aaa\u0abe\u0a9b\u0abe \u0a86\u0ab5\u0a95\u0abe\u0ab0 \u0a9b\u0ac7',
    signInToAccount: '\u0aa4\u0aae\u0abe\u0ab0\u0abe RetailCliQ \u0a96\u0abe\u0aa4\u0abe\u0aae\u0abe\u0a82 \u0ab8\u0abe\u0a87\u0aa8 \u0a87\u0aa8 \u0a95\u0ab0\u0acb',
    usernamePlaceholder: '\u0ab5\u0aaa\u0ab0\u0abe\u0ab6\u0a95\u0ab0\u0acd\u0aa4\u0abe \u0aa8\u0abe\u0aae \u0a85\u0aa5\u0ab5\u0abe \u0a88\u0aae\u0ac7\u0a87\u0ab2',
    passwordPlaceholder: '\u0aaa\u0abe\u0ab8\u0ab5\u0ab0\u0acd\u0aa1',
    rememberMe: '\u0aae\u0aa8\u0ac7 \u0aaf\u0abe\u0aa6 \u0ab0\u0abe\u0a96\u0acb',
    forgotPassword: '\u0aaa\u0abe\u0ab8\u0ab5\u0ab0\u0acd\u0aa1 \u0aad\u0ac2\u0ab2\u0acd\u0aaf\u0abe?',
    signInBtn: '\u0ab8\u0abe\u0a87\u0aa8 \u0a87\u0aa8',
    signingIn: '\u0ab8\u0abe\u0a87\u0aa8 \u0a87\u0aa8 \u0aa5\u0a88 \u0ab0\u0ab9\u0acd\u0aaf\u0ac1\u0a82 \u0a9b\u0ac7...',
    requestAccess: '\u0a8f\u0a95\u0acd\u0ab8\u0ac7\u0ab8 \u0ab5\u0abf\u0aa8\u0aa4\u0ac0',
    newTo: 'RetailCliQ \u0aae\u0abe\u0a82 \u0aa8\u0ab5\u0abe \u0a9b\u0acb?',
    verifyIdentity: '\u0aa4\u0aae\u0abe\u0ab0\u0ac0 \u0a93\u0ab3\u0a96 \u0a9a\u0a95\u0abe\u0ab8\u0acb',
    otpSentTo: '\u0a95\u0acb\u0aa1 \u0aae\u0acb\u0a95\u0ab2\u0abe\u0aaf\u0acb',
    verifyOtp: 'OTP \u0a9a\u0a95\u0abe\u0ab8\u0acb',
    resendOtp: 'OTP \u0aab\u0ab0\u0ac0 \u0aae\u0acb\u0a95\u0ab2\u0acb',
    backToLogin: '\u0ab2\u0ac9\u0a97\u0a87\u0aa8 \u0aaa\u0ab0 \u0aaa\u0abe\u0a9b\u0abe',
    goodMorning: '\u0ab8\u0ac1\u0aaa\u0acd\u0ab0\u0aad\u0abe\u0aa4',
    goodAfternoon: '\u0ab6\u0ac1\u0aad \u0aac\u0aaa\u0acb\u0ab0',
    goodEvening: '\u0ab6\u0ac1\u0aad \u0ab8\u0abe\u0a82\u0a9c',
    todayPulse: '\u0a86\u0a9c\u0aa8\u0ac0 \u0aa7\u0aa1\u0a95\u0aa8',
    recentActivity: '\u0aa4\u0abe\u0a9c\u0ac7\u0aa4\u0ab0\u0ac0\u0aa8 \u0aaa\u0acd\u0ab0\u0ab5\u0ac3\u0aa4\u0acd\u0aa4\u0abf',
    comingSoon: '\u0a9f\u0ac2\u0a82\u0a95 \u0ab8\u0aae\u0aaf\u0aae\u0abe\u0a82',
    selectBranch: '\u0ab6\u0abe\u0a96\u0abe \u0aaa\u0ab8\u0a82\u0aa6 \u0a95\u0ab0\u0acb',
    selectCompany: '\u0a95\u0a82\u0aaa\u0aa8\u0ac0 \u0aaa\u0ab8\u0a82\u0aa6 \u0a95\u0ab0\u0acb',
    systemStatus: '\u0ab8\u0abf\u0ab8\u0acd\u0a9f\u0aae \u0ab8\u0acd\u0aa5\u0abf\u0aa4\u0abf',
    allSystemsNormal: '\u0aac\u0aa7\u0abe \u0ab8\u0abf\u0ab8\u0acd\u0a9f\u0aae \u0ab8\u0abe\u0aae\u0abe\u0aa8\u0acd\u0aaf',
    operational: '\u0a9a\u0abe\u0ab2\u0ac1',
    language: '\u0aad\u0abe\u0ab7\u0abe',
    currency: '\u0a9a\u0ab2\u0aa3',
    selectLanguage: '\u0aad\u0abe\u0ab7\u0abe \u0aaa\u0ab8\u0a82\u0aa6 \u0a95\u0ab0\u0acb',
    selectCurrency: '\u0a9a\u0ab2\u0aa3 \u0aaa\u0ab8\u0a82\u0aa6 \u0a95\u0ab0\u0acb',
    demoCredentials: '\u0aa1\u0ac7\u0aae\u0acb \u0a95\u0acd\u0ab0\u0ac7\u0aa1\u0ac7\u0aa8\u0acd\u0ab6\u0abf\u0aaf\u0ab2',
    noMfaRequired: '(MFA \u0aa8\u0ab9\u0ac0\u0a82)',
    uptime: '\u0a85\u0aaa\u0a9f\u0abe\u0a87\u0aae',
    activeUsers: '\u0ab8\u0a95\u0acd\u0ab0\u0abf\u0aaf \u0ab5\u0aaa\u0ab0\u0abe\u0ab6\u0a95\u0ab0\u0acd\u0aa4\u0abe\u0a93',
    todayRevenue: '\u0a86\u0a9c\u0aa8\u0ac0 \u0a86\u0ab5\u0a95',
    pendingApprovals: '\u0aaa\u0ac7\u0aa8\u0acd\u0aa1\u0abf\u0a82\u0a97 \u0aae\u0a82\u0a9c\u0ac2\u0ab0\u0ac0',
    lowStockAlerts: '\u0a93\u0a9b\u0abe \u0ab8\u0acd\u0a9f\u0acb\u0a95 \u0a9a\u0ac7\u0aa4\u0ab5\u0aa3\u0ac0',
    recentLogins: '\u0aa4\u0abe\u0a9c\u0ac7\u0aa4\u0ab0\u0ac0 \u0ab2\u0ac9\u0a97\u0a87\u0aa8',
    quickActions: '\u0a9d\u0aa1\u0aaa \u0a95\u0abe\u0ab0\u0acd\u0aaf\u0ab5\u0abe\u0ab9\u0ac0',
    contactSupport: '\u0ab8\u0ab9\u0abe\u0aaf \u0ab8\u0a82\u0aaa\u0ab0\u0acd\u0a95',
    versionInfo: '\u0a86\u0ab5\u0ac3\u0aa4\u0acd\u0aa4\u0abf \u0aae\u0abe\u0ab9\u0abf\u0aa4\u0ac0',
  },
  mr: {
    welcomeBack: '\u092a\u0941\u0928\u094d\u0939\u093e \u0938\u094d\u0935\u093e\u0917\u0924 \u0906\u0939\u0947',
    signInToAccount: '\u0924\u0941\u092e\u091a\u094d\u092f\u093e RetailCliQ \u0916\u093e\u0924\u094d\u092f\u093e\u0924 \u0938\u093e\u0907\u0928 \u0907\u0928 \u0915\u0930\u093e',
    usernamePlaceholder: '\u0935\u093e\u092a\u0930\u0915\u0930\u094d\u0924\u094d\u092f\u093e\u091a\u0947 \u0928\u093e\u0935 \u0915\u093f\u0902\u0935\u093e \u0908\u092e\u0947\u0932',
    passwordPlaceholder: '\u092a\u093e\u0938\u0935\u0930\u094d\u0921',
    rememberMe: '\u092e\u0932\u093e \u0932\u0915\u094d\u0937\u093e\u0924 \u0920\u0947\u0935\u093e',
    forgotPassword: '\u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u0935\u093f\u0938\u0930\u0932\u093e?',
    signInBtn: '\u0938\u093e\u0907\u0928 \u0907\u0928',
    signingIn: '\u0938\u093e\u0907\u0928 \u0907\u0928 \u0939\u094b\u0924 \u0906\u0939\u0947...',
    requestAccess: '\u092a\u094d\u0930\u0935\u0947\u0936\u093e\u091a\u0940 \u0935\u093f\u0928\u0902\u0924\u0940',
    newTo: 'RetailCliQ \u092e\u0927\u094d\u092f\u0947 \u0928\u0935\u0940\u0928?',
    verifyIdentity: '\u0924\u0941\u092e\u091a\u0940 \u0913\u0933\u0916 \u092a\u0921\u0924\u093e\u0922\u0932\u093e',
    otpSentTo: '\u0915\u094b\u0921 \u092a\u093e\u0920\u0935\u0932\u093e',
    verifyOtp: 'OTP \u092a\u0921\u0924\u093e\u0922\u093e',
    resendOtp: 'OTP \u092a\u0941\u0928\u094d\u0939\u093e \u092a\u093e\u0920\u0935\u093e',
    backToLogin: '\u0932\u0949\u0917\u093f\u0928\u0935\u0930 \u092a\u0930\u0924 \u092f\u093e',
    goodMorning: '\u0938\u0941\u092a\u094d\u0930\u092d\u093e\u0924',
    goodAfternoon: '\u0936\u0941\u092d \u092e\u0927\u094d\u092f\u093e\u0928\u094d\u0939',
    goodEvening: '\u0936\u0941\u092d \u0938\u0902\u0927\u094d\u092f\u093e',
    todayPulse: '\u0906\u091c\u091a\u0940 \u0928\u093e\u0921\u0940',
    recentActivity: '\u0905\u0932\u0940\u0915\u0921\u0940\u0932 \u0915\u094d\u0930\u093f\u092f\u093e\u0915\u0932\u093e\u092a',
    comingSoon: '\u0932\u0935\u0915\u0930\u091a \u0909\u092a\u0932\u092c\u094d\u0927',
    selectBranch: '\u0936\u093e\u0916\u093e \u0928\u093f\u0935\u0921\u093e',
    selectCompany: '\u0915\u0902\u092a\u0928\u0940 \u0928\u093f\u0935\u0921\u093e',
    systemStatus: '\u092a\u094d\u0930\u0923\u093e\u0932\u0940 \u0938\u094d\u0925\u093f\u0924\u0940',
    allSystemsNormal: '\u0938\u0930\u094d\u0935 \u092a\u094d\u0930\u0923\u093e\u0932\u0940 \u0938\u093e\u092e\u093e\u0928\u094d\u092f',
    operational: '\u0915\u093e\u0930\u094d\u092f\u0930\u0924',
    language: '\u092d\u093e\u0937\u093e',
    currency: '\u091a\u0932\u0928',
    selectLanguage: '\u092d\u093e\u0937\u093e \u0928\u093f\u0935\u0921\u093e',
    selectCurrency: '\u091a\u0932\u0928 \u0928\u093f\u0935\u0921\u093e',
    demoCredentials: '\u0921\u0947\u092e\u094b \u0915\u094d\u0930\u0947\u0921\u0947\u0928\u094d\u0936\u093f\u092f\u0932',
    noMfaRequired: '(MFA \u0928\u093e\u0939\u0940)',
    uptime: '\u0905\u092a\u091f\u093e\u0907\u092e',
    activeUsers: '\u0938\u0915\u094d\u0930\u093f\u092f \u0935\u093e\u092a\u0930\u0915\u0930\u094d\u0924\u0947',
    todayRevenue: '\u0906\u091c\u091a\u0947 \u0909\u0924\u094d\u092a\u0928\u094d\u0928',
    pendingApprovals: '\u092a\u094d\u0930\u0932\u0902\u092c\u093f\u0924 \u092e\u0902\u091c\u0941\u0930\u0940',
    lowStockAlerts: '\u0915\u092e\u0940 \u0938\u093e\u0920\u093e \u0938\u0942\u091a\u0928\u093e',
    recentLogins: '\u0905\u0932\u0940\u0915\u0921\u0940\u0932 \u0932\u0949\u0917\u0907\u0928',
    quickActions: '\u0924\u094d\u0935\u0930\u093f\u0924 \u0915\u094d\u0930\u093f\u092f\u093e',
    contactSupport: '\u0938\u0902\u092a\u0930\u094d\u0915 \u0938\u0939\u093e\u092f\u094d\u092f\u0924\u093e',
    versionInfo: '\u0906\u0935\u0943\u0924\u094d\u0924\u0940 \u092e\u093e\u0939\u093f\u0924\u0940',
  },
  te: {
    welcomeBack: '\u0c2e\u0c33\u0c4d\u0c33\u0c40 \u0c38\u0c4d\u0c35\u0c3e\u0c17\u0c24\u0c02',
    signInToAccount: '\u0c2e\u0c40 RetailCliQ \u0c16\u0c3e\u0c24\u0c3e\u0c32\u0c4b \u0c38\u0c48\u0c28\u0c4d \u0c07\u0c28\u0c4d \u0c05\u0c35\u0c4d\u0c35\u0c02\u0c21\u0c3f',
    usernamePlaceholder: '\u0c2f\u0c42\u0c1c\u0c30\u0c4d\u200c\u0c28\u0c47\u0c2e\u0c4d \u0c32\u0c47\u0c26\u0c3e \u0c07\u0c2e\u0c46\u0c2f\u0c3f\u0c32\u0c4d',
    passwordPlaceholder: '\u0c2a\u0c3e\u0c38\u0c4d\u200c\u0c35\u0c30\u0c4d\u0c21\u0c4d',
    rememberMe: '\u0c28\u0c28\u0c4d\u0c28\u0c41 \u0c17\u0c41\u0c30\u0c4d\u0c24\u0c41\u0c02\u0c1a\u0c41\u0c15\u0c4b',
    forgotPassword: '\u0c2a\u0c3e\u0c38\u0c4d\u200c\u0c35\u0c30\u0c4d\u0c21\u0c4d \u0c2e\u0c30\u0c4d\u0c1a\u0c3f\u0c2a\u0c4b\u0c2f\u0c3e\u0c30\u0c3e?',
    signInBtn: '\u0c38\u0c48\u0c28\u0c4d \u0c07\u0c28\u0c4d',
    signingIn: '\u0c38\u0c48\u0c28\u0c4d \u0c07\u0c28\u0c4d \u0c05\u0c35\u0c41\u0c24\u0c4b\u0c02\u0c26\u0c3f...',
    requestAccess: '\u0c2f\u0c3e\u0c15\u0c4d\u0c38\u0c46\u0c38\u0c4d \u0c15\u0c4b\u0c38\u0c02 \u0c05\u0c2d\u0c4d\u0c2f\u0c30\u0c4d\u0c25\u0c3f\u0c02\u0c1a\u0c02\u0c21\u0c3f',
    newTo: 'RetailCliQ \u0c15\u0c41 \u0c15\u0c4a\u0c24\u0c4d\u0c24\u0c17\u0c3e \u0c35\u0c1a\u0c4d\u0c1a\u0c3e\u0c30\u0c3e?',
    verifyIdentity: '\u0c2e\u0c40 \u0c17\u0c41\u0c30\u0c4d\u0c24\u0c3f\u0c02\u0c2a\u0c41\u0c28\u0c41 \u0c27\u0c43\u0c35\u0c40\u0c15\u0c30\u0c3f\u0c02\u0c1a\u0c02\u0c21\u0c3f',
    otpSentTo: '\u0c15\u0c4b\u0c21\u0c4d \u0c2a\u0c02\u0c2a\u0c2c\u0c21\u0c3f\u0c02\u0c26\u0c3f',
    verifyOtp: 'OTP \u0c27\u0c43\u0c35\u0c40\u0c15\u0c30\u0c3f\u0c02\u0c1a\u0c02\u0c21\u0c3f',
    resendOtp: 'OTP \u0c2e\u0c33\u0c4d\u0c33\u0c40 \u0c2a\u0c02\u0c2a\u0c02\u0c21\u0c3f',
    backToLogin: '\u0c32\u0c3e\u0c17\u0c3f\u0c28\u0c4d\u0c15\u0c41 \u0c24\u0c3f\u0c30\u0c3f\u0c17\u0c3f \u0c35\u0c46\u0c33\u0c4d\u0c33\u0c02\u0c21\u0c3f',
    goodMorning: '\u0c36\u0c41\u0c2d\u0c4b\u0c26\u0c2f\u0c02',
    goodAfternoon: '\u0c36\u0c41\u0c2d \u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02',
    goodEvening: '\u0c36\u0c41\u0c2d \u0c38\u0c3e\u0c2f\u0c02\u0c15\u0c3e\u0c32\u0c02',
    todayPulse: '\u0c28\u0c47\u0c1f\u0c3f \u0c2a\u0c32\u0c4d\u0c38\u0c4d',
    recentActivity: '\u0c24\u0c3e\u0c1c\u0c3e \u0c15\u0c3e\u0c30\u0c4d\u0c2f\u0c15\u0c32\u0c3e\u0c2a\u0c02',
    comingSoon: '\u0c24\u0c4d\u0c35\u0c30\u0c32\u0c4b \u0c35\u0c38\u0c4d\u0c24\u0c41\u0c02\u0c26\u0c3f',
    selectBranch: '\u0c2c\u0c4d\u0c30\u0c3e\u0c02\u0c1a\u0c4d \u0c0e\u0c02\u0c1a\u0c41\u0c15\u0c4b\u0c02\u0c21\u0c3f',
    selectCompany: '\u0c15\u0c02\u0c2a\u0c46\u0c28\u0c40\u0c28\u0c3f \u0c0e\u0c02\u0c1a\u0c41\u0c15\u0c4b\u0c02\u0c21\u0c3f',
    systemStatus: '\u0c38\u0c3f\u0c38\u0c4d\u0c1f\u0c2e\u0c4d \u0c38\u0c4d\u0c25\u0c3f\u0c24\u0c3f',
    allSystemsNormal: '\u0c05\u0c28\u0c4d\u0c28\u0c3f \u0c38\u0c3f\u0c38\u0c4d\u0c1f\u0c2e\u0c4d\u0c32\u0c41 \u0c38\u0c3e\u0c27\u0c3e\u0c30\u0c02\u0c17\u0c3e \u0c09\u0c28\u0c4d\u0c28\u0c3e\u0c2f\u0c3f',
    operational: '\u0c15\u0c3e\u0c30\u0c4d\u0c2f\u0c28\u0c3f\u0c30\u0c4d\u0c35\u0c39\u0c23',
    language: '\u0c2b\u0c3e\u0c37',
    currency: '\u0c15\u0c30\u0c46\u0c28\u0c4d\u0c38\u0c40',
    selectLanguage: '\u0c2b\u0c3e\u0c37 \u0c0e\u0c02\u0c1a\u0c41\u0c15\u0c4b\u0c02\u0c21\u0c3f',
    selectCurrency: '\u0c15\u0c30\u0c46\u0c28\u0c4d\u0c38\u0c40 \u0c0e\u0c02\u0c1a\u0c41\u0c15\u0c4b\u0c02\u0c21\u0c3f',
    demoCredentials: '\u0c21\u0c46\u0c2e\u0c4b \u0c15\u0c4d\u0c30\u0c46\u0c21\u0c46\u0c28\u0c4d\u0c37\u0c3f\u0c2f\u0c32\u0c4d\u0c38\u0c4d',
    noMfaRequired: '(MFA \u0c05\u0c35\u0c38\u0c30\u0c02 \u0c32\u0c47\u0c26\u0c41)',
    uptime: '\u0c05\u0c2a\u0c4d\u200c\u0c1f\u0c48\u0c2e\u0c4d',
    activeUsers: '\u0c15\u0c4d\u0c30\u0c3f\u0c2f\u0c3e\u0c36\u0c40\u0c32 \u0c2f\u0c42\u0c1c\u0c30\u0c4d\u0c32\u0c41',
    todayRevenue: '\u0c28\u0c47\u0c1f\u0c3f \u0c06\u0c26\u0c3e\u0c2f\u0c02',
    pendingApprovals: '\u0c2a\u0c46\u0c02\u0c21\u0c3f\u0c02\u0c17\u0c4d \u0c06\u0c2e\u0c4b\u0c26\u0c3e\u0c32\u0c41',
    lowStockAlerts: '\u0c24\u0c15\u0c4d\u0c15\u0c41\u0c35 \u0c38\u0c4d\u0c1f\u0c3e\u0c15\u0c4d \u0c39\u0c46\u0c1a\u0c4d\u0c1a\u0c30\u0c3f\u0c15\u0c32\u0c41',
    recentLogins: '\u0c24\u0c3e\u0c1c\u0c3e \u0c32\u0c3e\u0c17\u0c3f\u0c28\u0c4d\u0c32\u0c41',
    quickActions: '\u0c24\u0c4d\u0c35\u0c30\u0c3f\u0c24 \u0c1a\u0c30\u0c4d\u0c2f\u0c32\u0c41',
    contactSupport: '\u0c38\u0c2a\u0c4b\u0c30\u0c4d\u0c1f\u0c4d\u0c28\u0c41 \u0c38\u0c02\u0c2a\u0c4d\u0c30\u0c26\u0c3f\u0c02\u0c1a\u0c02\u0c21\u0c3f',
    versionInfo: '\u0c35\u0c46\u0c30\u0c4d\u0c37\u0c28\u0c4d \u0c38\u0c2e\u0c3e\u0c1a\u0c3e\u0c30\u0c02',
  },
  kn: {
    welcomeBack: 'ಮತ್ತೆ ಸ್ವಾಗತ',
    signInToAccount: 'ನಿಮ್ಮ RetailCliQ ಖಾತೆಗೆ ಸೈನ್ ಇನ್ ಮಾಡಿ',
    usernamePlaceholder: 'ಬಳಕೆದಾರ ಹೆಸರು ಅಥವಾ ಇಮೇಲ್',
    passwordPlaceholder: 'ಪಾಸ್‌ವರ್ಡ್',
    rememberMe: 'ನನ್ನನ್ನು ನೆನಪಿಡಿ',
    forgotPassword: 'ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿರಾ?',
    signInBtn: 'ಸೈನ್ ಇನ್',
    signingIn: 'ಸೈನ್ ಇನ್ ಆಗುತ್ತಿದೆ...',
    requestAccess: 'ಪ್ರವೇಶಕ್ಕಾಗಿ ವಿನಂತಿಸಿ',
    newTo: 'RetailCliQ ಗೆ ಹೊಸಬರೇ?',
    verifyIdentity: 'ನಿಮ್ಮ ಗುರುತನ್ನು ಪರಿಶೀಲಿಸಿ',
    otpSentTo: 'ಕೋಡ್ ಕಳುಹಿಸಲಾಗಿದೆ',
    verifyOtp: 'OTP ಪರಿಶೀಲಿಸಿ',
    resendOtp: 'OTP ಮತ್ತೆ ಕಳುಹಿಸಿ',
    backToLogin: 'ಲಾಗಿನ್‌ಗೆ ಹಿಂತಿರುಗಿ',
    goodMorning: 'ಶುಭೋದಯ',
    goodAfternoon: 'ಶುಭ ಮಧ್ಯಾಹ್ನ',
    goodEvening: 'ಶುಭ ಸಂಜೆ',
    todayPulse: 'ಇಂದಿನ ಪಲ್ಸ್',
    recentActivity: 'ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ',
    comingSoon: 'ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತಿದೆ',
    selectBranch: 'ಶಾಖೆ ಆಯ್ಕೆಮಾಡಿ',
    selectCompany: 'ಕಂಪನಿ ಆಯ್ಕೆಮಾಡಿ',
    systemStatus: 'ಸಿಸ್ಟಮ್ ಸ್ಥಿತಿ',
    allSystemsNormal: 'ಎಲ್ಲಾ ಸಿಸ್ಟಮ್‌ಗಳು ಸಾಮಾನ್ಯವಾಗಿವೆ',
    operational: 'ಕಾರ್ಯನಿರ್ವಹಣೆ',
    language: 'ಭಾಷೆ',
    currency: 'ಕರೆನ್ಸಿ',
    selectLanguage: 'ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ',
    selectCurrency: 'ಕರೆನ್ಸಿ ಆಯ್ಕೆಮಾಡಿ',
    demoCredentials: 'ಡೆಮೊ ರುಜುವಾತುಗಳು',
    noMfaRequired: '(MFA ಅಗತ್ಯವಿಲ್ಲ)',
    uptime: 'ಅಪ್‌ಟೈಮ್',
    activeUsers: 'ಸಕ್ರಿಯ ಬಳಕೆದಾರರು',
    todayRevenue: 'ಇಂದಿನ ಆದಾಯ',
    pendingApprovals: 'ಬಾಕಿ ಅನುಮೋದನೆಗಳು',
    lowStockAlerts: 'ಕಡಿಮೆ ಸ್ಟಾಕ್ ಎಚ್ಚರಿಕೆಗಳು',
    recentLogins: 'ಇತ್ತೀಚಿನ ಲಾಗಿನ್‌ಗಳು',
    quickActions: 'ತ್ವರಿತ ಕ್ರಿಯೆಗಳು',
    contactSupport: 'ಸಹಾಯವನ್ನು ಸಂಪರ್ಕಿಸಿ',
    versionInfo: 'ಆವೃತ್ತಿ ಮಾಹಿತಿ',
  },
  de: {
    welcomeBack: 'Willkommen zur\u00fcck',
    signInToAccount: 'Melden Sie sich bei Ihrem RetailCliQ-Konto an',
    usernamePlaceholder: 'Benutzername oder E-Mail',
    passwordPlaceholder: 'Passwort',
    rememberMe: 'Angemeldet bleiben',
    forgotPassword: 'Passwort vergessen?',
    signInBtn: 'Anmelden',
    signingIn: 'Anmeldung l\u00e4uft...',
    requestAccess: 'Zugang anfordern',
    newTo: 'Neu bei RetailCliQ?',
    verifyIdentity: 'Identit\u00e4t verifizieren',
    otpSentTo: 'Code gesendet an',
    verifyOtp: 'OTP verifizieren',
    resendOtp: 'OTP erneut senden',
    backToLogin: 'Zur\u00fcck zur Anmeldung',
    goodMorning: 'Guten Morgen',
    goodAfternoon: 'Guten Tag',
    goodEvening: 'Guten Abend',
    todayPulse: 'Tages\u00fcberblick',
    recentActivity: 'Letzte Aktivit\u00e4t',
    comingSoon: 'Demn\u00e4chst verf\u00fcgbar',
    selectBranch: 'Filiale ausw\u00e4hlen',
    selectCompany: 'Unternehmen ausw\u00e4hlen',
    systemStatus: 'Systemstatus',
    allSystemsNormal: 'Alle Systeme normal',
    operational: 'Betriebsbereit',
    language: 'Sprache',
    currency: 'W\u00e4hrung',
    selectLanguage: 'Sprache ausw\u00e4hlen',
    selectCurrency: 'W\u00e4hrung ausw\u00e4hlen',
    demoCredentials: 'Demo-Zugangsdaten',
    noMfaRequired: '(Keine MFA erforderlich)',
    uptime: 'Verf\u00fcgbarkeit',
    activeUsers: 'Aktive Benutzer',
    todayRevenue: 'Heutiger Umsatz',
    pendingApprovals: 'Ausstehende Genehmigungen',
    lowStockAlerts: 'Warnungen bei niedrigem Bestand',
    recentLogins: 'Letzte Anmeldungen',
    quickActions: 'Schnellaktionen',
    contactSupport: 'Support kontaktieren',
    versionInfo: 'Versionsinformationen',
  },
  zh: {
    welcomeBack: '\u6b22\u8fce\u56de\u6765',
    signInToAccount: '\u767b\u5f55\u60a8\u7684 RetailCliQ \u8d26\u6237',
    usernamePlaceholder: '\u7528\u6237\u540d\u6216\u7535\u5b50\u90ae\u4ef6',
    passwordPlaceholder: '\u5bc6\u7801',
    rememberMe: '\u8bb0\u4f4f\u6211',
    forgotPassword: '\u5fd8\u8bb0\u5bc6\u7801\uff1f',
    signInBtn: '\u767b\u5f55',
    signingIn: '\u6b63\u5728\u767b\u5f55...',
    requestAccess: '\u7533\u8bf7\u8bbf\u95ee\u6743\u9650',
    newTo: 'RetailCliQ \u65b0\u7528\u6237\uff1f',
    verifyIdentity: '\u9a8c\u8bc1\u60a8\u7684\u8eab\u4efd',
    otpSentTo: '\u9a8c\u8bc1\u7801\u5df2\u53d1\u9001\u81f3',
    verifyOtp: '\u9a8c\u8bc1 OTP',
    resendOtp: '\u91cd\u65b0\u53d1\u9001 OTP',
    backToLogin: '\u8fd4\u56de\u767b\u5f55',
    goodMorning: '\u65e9\u4e0a\u597d',
    goodAfternoon: '\u4e0b\u5348\u597d',
    goodEvening: '\u665a\u4e0a\u597d',
    todayPulse: '\u4eca\u65e5\u6982\u89c8',
    recentActivity: '\u6700\u8fd1\u6d3b\u52a8',
    comingSoon: '\u5373\u5c06\u63a8\u51fa',
    selectBranch: '\u9009\u62e9\u5206\u5e97',
    selectCompany: '\u9009\u62e9\u516c\u53f8',
    systemStatus: '\u7cfb\u7edf\u72b6\u6001',
    allSystemsNormal: '\u6240\u6709\u7cfb\u7edf\u6b63\u5e38',
    operational: '\u8fd0\u884c\u4e2d',
    language: '\u8bed\u8a00',
    currency: '\u8d27\u5e01',
    selectLanguage: '\u9009\u62e9\u8bed\u8a00',
    selectCurrency: '\u9009\u62e9\u8d27\u5e01',
    demoCredentials: '\u6f14\u793a\u51ed\u636e',
    noMfaRequired: '\uff08\u65e0\u9700 MFA\uff09',
    uptime: '\u6b63\u5e38\u8fd0\u884c\u65f6\u95f4',
    activeUsers: '\u6d3b\u8dc3\u7528\u6237',
    todayRevenue: '\u4eca\u65e5\u6536\u5165',
    pendingApprovals: '\u5f85\u6279\u51c6\u4e8b\u9879',
    lowStockAlerts: '\u5e93\u5b58\u4e0d\u8db3\u63d0\u9192',
    recentLogins: '\u6700\u8fd1\u767b\u5f55',
    quickActions: '\u5feb\u6377\u64cd\u4f5c',
    contactSupport: '\u8054\u7cfb\u652f\u6301',
    versionInfo: '\u7248\u672c\u4fe1\u606f',
  },
};

export const getTranslations = (langCode) => TRANSLATIONS[langCode] || TRANSLATIONS.en;
export const t = (langCode, key) => (TRANSLATIONS[langCode] && TRANSLATIONS[langCode][key]) || (TRANSLATIONS.en[key] || key);
